import React from 'react';
import Icon from './Icon';

/**
 * En-tête commun des pages de l'espace admin (nouvelle charte).
 */
const PageHeader = ({ icon, title, subtitle, actions }) => (
    <header className="c2-page-header c2-fade-up">
        <div className="c2-page-header__titles">
            {icon && <span className="c2-page-header__icon"><Icon name={icon} size={24} /></span>}
            <div>
                <h1>{title}</h1>
                {subtitle && <p className="c2-page-header__subtitle">{subtitle}</p>}
            </div>
        </div>
        {actions && <div className="c2-page-header__actions">{actions}</div>}
    </header>
);

export default PageHeader;
